"use strict";

import React from "react";
import { Box, Button } from "@showitinc/showit-wc";
import _ from "lodash";
import SubdomainNameUpdateForm from "./SubdomainNameUpdateForm.jsx";
import DomainActions from "../../actions/DomainActions";
import { showDomainSetupModal } from "../../adaptors/ModalAdaptors";
import { toUnicode } from "../../utils/DomainUtils.js";

class DomainManageView extends React.Component {
  _cancel = () => {
    this.props.onCancel();
  };

  _enableSubdomain = () => {
    const domain = this.props.domain;
    DomainActions.enableSubdomain(domain);
  };

  _disableSubdomain = () => {
    const domain = this.props.domain;
    DomainActions.disableSubdomain(domain);
  };

  _updateSubdomainName = (data) => {
    const domain = this.props.domain;
    DomainActions.renameSubdomain(domain, data);
  };

  _setupPrimaryDomain = showDomainSetupModal;

  _getSubdomainView = (domain) => {
    let isDisabled = domain.disabled > 0;
    let { primaryDomain, saving } = this.props;

    let view = null;
    if (isDisabled) {
      view = (
        <div style={{ textAlign: "center", margin: "20px auto 0", width: "60%" }}>
          This site is currently disabled and is not visible on the Internet. Click 'Enable' to make
          this site visible.
          <div>
            <Box mt="3">
              <Button variant="feature" onClick={this._enableSubdomain} disabled={saving}>
                Enable
              </Button>
            </Box>
          </div>
        </div>
      );
    } else {
      view = (
        <div style={{ textAlign: "center" }}>
          <div style={{ margin: "20px auto 0", width: "60%" }}>
            Update the URL of this +Site Domain
            <SubdomainNameUpdateForm
              name={domain.web_name}
              primaryDomain={primaryDomain}
              onNameUpdate={this._updateSubdomainName}
              updateMode={true}
              submitting={saving}
            />
          </div>
          <div style={{ marginTop: 40 }}>
            This site is currently enabled and is visible on the Internet. Click 'Disable' to hide
            this site.
            <Box mt="3">
              <Button variant="feature" onClick={this._disableSubdomain} disabled={saving}>
                Disable
              </Button>
            </Box>
          </div>
        </div>
      );
    }

    return <div>{view}</div>;
  };

  _getPrimaryDomainView = (domain) => {
    return (
      <div>
        <p className={"instrux"}>
          This is your <span onDoubleClick={this._setupPrimaryDomain}>primary domain</span>. You can
          create +Site subdomains based off this domain.
        </p>
        <p className={"instrux"}>
          If you need to need to change your domain name please contact Showit Support.
        </p>
      </div>
    );
  };

  render() {
    const domain = this.props.domain;
    const isSubdomain = _.isNumber(domain.parent_site_id);
    let message = null;
    const error = this.props.error;
    const updated = this.props.updated;

    const view = isSubdomain ? this._getSubdomainView(domain) : this._getPrimaryDomainView(domain);

    if (error) {
      message = (
        <div className={"has-error"}>
          <div className={"help-block"}>{error.message}</div>
        </div>
      );
    } else if (updated) {
      message = (
        <div className={"has-success"}>
          <div className={"help-block"}>Domain Updated</div>
        </div>
      );
    } else {
      message = <div>&nbsp;</div>;
    }

    return (
      <div style={{ padding: 16 }}>
        <h4 style={{ fontSize: 26, fontWeight: 300, margin: 0 }}>
          {toUnicode(domain.domain_name || "")}
        </h4>
        {message}
        {view}
        <Button
          variant="minimal"
          style={{ position: "absolute", bottom: 10, right: 10 }}
          onClick={this._cancel}
          disabled={this.props.saving}
        >
          Done
        </Button>
      </div>
    );
  }
}

export default DomainManageView;
